import React from 'react';
import bilbylogo from '../assets/logo.svg';

interface LogoProps {
  isCompact?: boolean;
}

const Logo: React.FC<LogoProps> = ({ isCompact = false }) => {
  const dimensions = isCompact
    ? { width: '56px', height: '56px' }
    : { width: '140px', height: '48px' };

  return <img src={bilbylogo} alt="Bilby Logo" style={dimensions} />;
};

export default Logo;
